var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.914 16.085a.372.372 0 0 1 0 .476l-2.354 2.353a.372.372 0 0 1-.475 0L12 14.83l-4.085 4.084a.372.372 0 0 1-.476 0L5.087 16.56a.372.372 0 0 1 0-.475L9.17 12 5.086 7.915a.372.372 0 0 1 0-.476L7.44 5.087a.372.372 0 0 1 .475 0L12 9.17l4.085-4.084a.372.372 0 0 1 .476 0l2.353 2.354a.372.372 0 0 1 0 .475L14.83 12l4.084 4.085z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3d95f13f05e82a49dc122a74705485ef.svg";
export { ForwardRef as ReactComponent };